export default Object.freeze({
  AUTHORIZATION: '12:eMv4902mz6tKz0daqEwATeHBUYJEyn3KVDfQkIhM',
  BEARER: 'Bearer ',
  CLIENT_BOOKING_EXCLUSION_PERIOD: 0,
  EXTERNAL_CLIENT_ID: 1,
  DATE_OF_BIRTH_MIN_AGE: 16,
  DATE_OF_BIRTH_MIN_YEAR: 100,
  FIREBASEAPIKEY: 'AIzaSyBTqoXrsh-fqHvapzUan4il8CkDWAkwS0s',
  FIREBASEAPPID: '1:906576866290:web:0a8cf49b14f40e6c75d96b',
  FIREBASEMESSAGINGSENDERID: '906576866290',
  FIREBASEPROJECTID: 'dwff-client-p',
  FIREBASEPUBLICVAPIDKEY: 'BC0BcHjcrmXQayLDCeUVFrH4zONzo_Jc0QAwCBxV4VSDIw9Cs88F332yytD8DbSnigHel03dh9vkXgNLPuFV1Xs',
  GOOGLEMAPS: 'AIzaSyA9O5iT3CyuB9Wq_pJW22tF92UC3XLXlgE',
  MODE_EDIT: 'edit',
  MODE_VIEW: 'view',
  OPERATOR: 2,
  OPERATOR_DWFF: 2,
  OPERATOR_GODO: 3,
  OPERATOR_PUREGYM: 11,
  OPERATOR_STAR: 1,
  SEARCH_BY_GYM: 'SEARCH_BY_GYM',
  SEARCH_BY_GYM_ONLINE: 'SEARCH_BY_GYM_ONLINE',
  SEARCH_BY_LOCATION: 'SEARCH_BY_LOCATION',
  STATUS_ACCEPTED: 'Accepted',
  STATUS_AVAILABLE: 'Available',
  STATUS_CANCELLED: 'Cancelled',
  STATUS_COMPLETED: 'Completed',
  STATUS_REDEEMED: 'Redeemed',
  STATUS_REJECTED: 'Rejected',
  STATUS_REQUESTED: 'Requested',
  STATUS_UNCOMPLETED_CLIENT: 'Uncompleted/Client',
  STATUS_UNCOMPLETED_PROFESSIONAL: 'Uncompleted/Professional',
  STATUS_UNVERIFIED: 0,
  STATUS_VERIFIED: 1,
  TITLE: 'DW Fitness First',
  TITLE_BRAND: 'Go:Do',
  TYPE_QUALIFICATION: 'qualification',
  URL: 'https://godo.fitness/api/beta',
  URLV1: 'https://godo.fitness/api/v1',
  USER_TYPE: 'client',
  USER_TYPE_CLIENT: 'client',
  USER_TYPE_PROFESSIONAL: 'professional',
  VERSION: process.env.VERSION,
  VAPID: '',
  WORLDPAY: 'L_C_fde86e23-85ed-4ce1-92dc-ae4fdd447aa0',
  ZOOM_REDIRECT_URI: ''
})
